<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .resume-container {
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(16px);
    gap: utils.in_rem(16px);
    overflow-y: auto;

    .header {
      display: flex;
      justify-content: space-between;
    }

    .resume-history {
      display: flex;
      flex-direction: column;
      padding: utils.in_rem(16px) 0;
      gap: utils.in_rem(16px);
      border-top: 1px solid colors.get(interfaceSwGrey_10);
    }
  }
</style>

<script>
  import Link from "@sourcewhale/shared/svelte-design-system/components/atoms/Link.svelte";
  import EducationSection from "../../components/BackgroundModal/EducationSection.svelte";
  import ExperienceSection from "../../components/BackgroundModal/ExperienceSection.svelte";
  import ContactInfo from "./ContactInfo.svelte";

  let { resume = {}, contactEmail } = $props();

  let experience = $derived(resume.experience ?? []);
  let education = $derived(resume.education ?? []);
</script>

<div class="resume-container">
  <div class="header">
    <ContactInfo {resume} />
    {#if contactEmail}
      <Link
        href="mailto:{contactEmail}"
        target="_blank"
        rel="noopener noreferrer"
      >
        Contact us
      </Link>
    {/if}
  </div>
  <div class="resume-history">
    {#if experience.length}
      <ExperienceSection {experience} />
    {/if}
    {#if education.length}
      <EducationSection {education} />
    {/if}
  </div>
</div>
